__webpack_require__.p = "/acquisition-adjust-segment-events/system-email-templates/";